// extracted by extract-css-chunks-webpack-plugin
module.exports = {"relateShortRecom":"relateShortRecom-2pkFlYWx","shortAppTxt":"shortAppTxt-1whYQu-M","boxBottomLine":"boxBottomLine-2-sxXz-r"};